function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9932 30.0533L17.0065 30.0627C19.3798 31.5738 22.4844 31.2329 24.4732 29.2427L25.3118 28.404C25.6872 28.0289 25.8981 27.52 25.8981 26.9893C25.8981 26.4587 25.6872 25.9498 25.3118 25.5747L21.7745 22.04C21.3994 21.6647 20.8905 21.4538 20.3598 21.4538C19.8292 21.4538 19.3203 21.6647 18.9452 22.04V22.04C18.1642 22.8208 16.8982 22.8208 16.1172 22.04L10.4612 16.3827C9.68041 15.6017 9.68041 14.3357 10.4612 13.5547V13.5547C10.8365 13.1796 11.0474 12.6707 11.0474 12.14C11.0474 11.6094 10.8365 11.1005 10.4612 10.7253L6.92517 7.19068C6.14417 6.40991 4.87817 6.40991 4.09717 7.19068L3.25717 8.02934C1.26742 10.0185 0.927033 13.123 2.43851 15.496L2.44651 15.5093C6.32141 21.2424 11.2594 26.1795 16.9932 30.0533V30.0533Z",
  stroke: "#009A8A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5 15C28.366 15 31.5 11.866 31.5 8C31.5 4.13401 28.366 1 24.5 1C20.634 1 17.5 4.13401 17.5 8C17.5 11.866 20.634 15 24.5 15Z",
  stroke: "#009A8A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6216 5.87866L22.3789 10.1213",
  stroke: "#009A8A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3789 5.87866L26.6216 10.1213",
  stroke: "#009A8A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var SvgPhoneActionsRemove = function SvgPhoneActionsRemove(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneActionsRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-actions-remove.0a26a2f8.svg";
export { ForwardRef as ReactComponent };